exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".c-photo-uploader__button {\n  width: 100%;\n}\n\n.c-photo-uploader__file {\n  display: none;\n}\n\n.c-photo-uploader__preview {\n  margin-top: .5rem;\n}", ""]);

